import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {ShipmentsService} from "../services/shipments.service";
import {ShipmentEventModalComponent} from "../shipment-event-modal/shipment-event-modal.component";
import {Shipment} from "../services/shipment";
import {ShipmentEvent} from "../services/shipment-event";
import * as moment from "moment/moment";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ShipmentAddressPickerComponent} from "../shipment-address-picker/shipment-address-picker.component";

@Component({
    selector: 'app-edit-adresses-form',
    templateUrl: './edit-adresses-form.component.html',
    styleUrls: ['./edit-adresses-form.component.scss']
})
export class EditAdressesFormComponent implements OnInit, OnChanges {

    @Input() _shipment: any;
    @Input() simple!: boolean;
    @Input() saving!: boolean;

    @Output() stuffChanged = new EventEmitter<any>();

    protected checking: boolean;

    moved = false;
    addresses;
    addressesFound = null;
    mapCenter = [8.264862, 56.093567];

    public droppointResults: any[] = [];
    protected newAddress: any;
    protected missingAdressTypes: any[] = [];

    constructor(public shipmentsService: ShipmentsService, public ngbModal: NgbModal) {
    }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes._shipment && this._shipment.shipment_address) {
            this.mapCenter = [this._shipment.shipment_address.x, this._shipment.shipment_address.y];
        }
    }

    checkAddress() {

        this.checking = true;

        if (this._shipment.shipment_addresses) {

            this._shipment.shipment_addresses.forEach((shipment_address) => {

                if (shipment_address.address_type === 'receiver') {

                    this.shipmentsService.searchGoogleGeocode(shipment_address.id, shipment_address.adress_1_receiver, shipment_address.postal_code_receiver).then(addresses => {
                            this.addresses = addresses.data;
                            if (this.addresses.length === 1) {
                                shipment_address.x = this.addresses[0].x;
                                shipment_address.y = this.addresses[0].y;
                                this.mapCenter = [this.addresses[0].x, this.addresses[0].y];
                            }
                            this.addressesFound = addresses.data.length;
                            this.checking = false;
                        }
                    );
                }
            });
        }
    }


    onDragEnd(marker: any) {
        this.moved = true;
        this.mapCenter = Object.keys(marker).map((key) => marker[key]);
        this._shipment.shipment_addresses.forEach((shipment_address) => {
            if (shipment_address.address_type === 'receiver') {
                shipment_address.x = this.mapCenter[0];
                shipment_address.y = this.mapCenter[1];
            }
        });
    }

    lookupDroppoint() {
        this.shipmentsService.reloadHeaders();
        const reciever = this._shipment.shipment_addresses.find(address => address.address_type === 'receiver');
        const droppointAdresse = this._shipment.shipment_addresses.find(address => address.address_type === 'droppoint');
        const searchAdresse = {
            droppoint_reference: droppointAdresse.droppoint_reference,
            postal_code_receiver: reciever.postal_code_receiver,
            adress_1_receiver: reciever.adress_1_receiver,
        }

        this.shipmentsService.lookupDroppoint(this._shipment, searchAdresse).subscribe(response => {
            this.droppointResults = response.data;
        })
    }

    pickDroppoint(droppoint: any) {
        const dropointaddress = this._shipment.shipment_addresses.find(address => address.address_type === 'droppoint');
        dropointaddress.droppoint_reference = droppoint.id;
        dropointaddress.name_1_receiver = droppoint.name;
        dropointaddress.adress_1_receiver = droppoint.address;
        dropointaddress.adress_2_receiver = droppoint.address2;
        dropointaddress.postal_code_receiver = droppoint.zipcode;
        dropointaddress.city_receiver = droppoint.city;
        dropointaddress.country_code_receiver = droppoint.country;

        this.droppointResults = [];
        this.stuffChanged.emit(true);
    }

    showOnMap(address) {
        this.moved = false;
        this._shipment.shipment_addresses.forEach((shipment_address) => {
            if (shipment_address.address_type === 'receiver') {
                shipment_address.x = address.x;
                shipment_address.y = address.y;
            }
        });
        this.mapCenter = [address.x, address.y];
    }

    pickAddress(address) {

        this._shipment.shipment_addresses.forEach((shipment_address) => {
            if (shipment_address.address_type === 'receiver') {
                shipment_address.x = address.x;
                shipment_address.y = address.y;
            }
        });

        this.stuffChanged.emit(true);
    }


    pickAdress(destination) {
        const modalRef = this.ngbModal.open(ShipmentAddressPickerComponent, {size: 'lg'});
        modalRef.componentInstance.modal = modalRef;
        modalRef.componentInstance.picked.subscribe((result: any) => {
            if (!destination) {
                destination = {address_type: 'receiver'};
                console.log('creating receiver address', destination);
                this._shipment.shipment_addresses.push(destination);
            }

            const receiverFields = [
                'name_1_receiver',
                'name_2_receiver',
                'adress_1_receiver',
                'adress_2_receiver',
                'postal_code_receiver',
                'city_receiver',
                'country_code_receiver',
                'phone_receiver',
                'email_receiver',
                'droppoint_reference'
            ];

            receiverFields.forEach((field) => {
                if (field in result) {
                    destination[field] = result[field];
                }
            });

            modalRef.close();
           this.stuffChanged.emit(true);
        });
    }

    protected saveInAdressbook(shipment_address: any) {
        const {id, shipment_id, ...addressCopy} = shipment_address;
        this.shipmentsService.addShipmentAddress(addressCopy).subscribe(result => {
            alert('done');
        })
    }

    protected startAddinAdress() {
        const possible = [
            {address_type: 'sender', name: 'Afsender'},
            {address_type: 'droppoint', name: 'DropPoint'},
            {address_type: 'pickup', name: 'Afhenter'},
            {address_type: 'receiver', name: 'Modtager'},
        ];

        this.missingAdressTypes = possible.filter(type => !this._shipment.shipment_addresses.some(address => address.address_type === type.address_type));
        this.newAddress = {
            address_type: null,
            name_1_receiver: '',
            name_2_receiver: '',
            adress_1_receiver: '',
            adress_2_receiver: '',
            postal_code_receiver: '',
            city_receiver: '',
            country_code_receiver: '',
            phone_receiver: '',
            email_receiver: '',
            droppoint_reference: ''
        };
    }

    protected addAddress() {
        if (!this.newAddress || !this.newAddress.address_type) {
            return;
        }

        if (!this._shipment.shipment_addresses) {
            this._shipment.shipment_addresses = [];
        }

        this._shipment.shipment_addresses.push(this.newAddress);
        this.newAddress = null;
        this.missingAdressTypes = [];
    }
}
